import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "63",
  height: "63",
  viewBox: "0 0 63 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 31.5C0 39.8543 3.31874 47.8665 9.22614 53.7739C15.1335 59.6813 23.1457 63 31.5 63C39.8543 63 47.8665 59.6813 53.7739 53.7739C59.6813 47.8665 63 39.8543 63 31.5C63 23.1457 59.6813 15.1335 53.7739 9.22614C47.8665 3.31874 39.8543 0 31.5 0C23.1457 0 15.1335 3.31874 9.22614 9.22614C3.31874 15.1335 0 23.1457 0 31.5Z",
  fill: "#E2DB08"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M31 17.5V32.8764C31 32.9521 31.0428 33.0214 31.1106 33.0553L46 40.5",
  stroke: "white",
  "stroke-width": "6",
  "stroke-linecap": "round"
}, null, -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default render